/* eslint-disable react-hooks/exhaustive-deps */
import { Draggable, Droppable } from "react-beautiful-dnd";
import "./column.scss";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import moment from "moment";
import api from "api";
import { useParams } from "react-router-dom";
import { BoardMemberType, ColumnType, RootState, SubscriptionType } from "types";
import Tickets from "components/board/tickets";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "redux/reducers";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "components/modal";
import { toast } from "react-toastify";

interface props {
    item: ColumnType;
    columns: ColumnType[];
    setColumns: React.Dispatch<React.SetStateAction<ColumnType[]>>;
    deleteColumn: (id: number) => void;
    getColumns: () => void;
    index: number;
    removeAllCardsFromColumns: any;
    allColumns: ColumnType[];
}

function Column({ item, deleteColumn, columns, setColumns, getColumns, index, removeAllCardsFromColumns, allColumns }: props) {
    const dispatch = useDispatch();

    const params: any = useParams();

    const user = useSelector((state: RootState) => state.user);
    const board = useSelector((state: RootState) => state.board);

    const [column, setColumn] = useState<ColumnType>(item);
    const [columnTitle, setColumnTitle] = useState<string>(item.Column.Description);
    const [isSorting, setIsSorting] = useState(true);
    // const [preference, setPreference] = useState(localStorage.getItem("sortPreference"));
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const [sorted, setSorted] = useState(false);
    const [moveCardsModalOpen, setMoveCardsModalOpen] = useState<Boolean>(false);
    const [destinationColumnId, setDestinationColumnId] = useState<number>(0);
    const [newTicket, setNewTicket] = useState<any>({
        open: false,
        title: "",
        dueDate: "",
    });
    const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
    const [isBoardAdmin, setIsBoardAdmin] = useState<boolean>(false);

    const addTicket = async () => {
        const date = newTicket.dueDate ? moment(newTicket.dueDate).format("DD MMM YYYY") : "";
        await api.ticket.add(params.clientId, params.boardId, newTicket.title, "", date, column!.Tickets.length).then(() => {
            dispatch(actions.board.set({ ...board }));

            setNewTicket({
                open: false,
                title: "",
                dueDate: "",
            });
        });
        //getColumns();
    };

    const updateColumn = () => {
        dispatch(actions.columns.update(column));
        api.column.update(params.clientId, params.boardId, column.Column.Id, columnTitle, column.Column.Position).then(() => {
            toast.success("Column updated");
        });
    };

    const SortColumn = () => {
        const sortPreference = localStorage.getItem("sortPreference");
        // setPreference(sortPreference);
        setIsSorting(true);

        switch (sortPreference) {
            // case "0":
            //     column.Tickets = column.Tickets.sort((a, b) => (a.DateCreated < b.DateCreated ? -1 : 1));
            //     console.log(column.Tickets);
            //     setSorted(true);
            //     setIsSorting(false);
            //     break;

            case "1":
                // column.Tickets = column.Tickets.sort((a, b) => (a.DueDate! < b.DueDate! ? -1 : 1));
                setSorted(true);
                setIsSorting(false);
                break;

            case "2":
                // column.Tickets = column.Tickets.sort((a, b) => (a.Heading > b.Heading ? 1 : -1));
                setSorted(true);
                setIsSorting(false);
                break;

            // case "3":
            //     // column.Tickets = column.Tickets.sort((a, b) => a.Position - b.Position).map((e) => ({ ...e, Assignee: e.Assignee.sort((x: any, y: any) => (x.Name > y.Name ? 1 : -1)) }));
            //     column.Tickets = column.Tickets.sort((a, b) => (a.Assignee?.Name > b.Assignee?.Name ? 1 : -1));
            //     console.log(column.Tickets);
            //     setSorted(true);
            //     setIsSorting(false);
            //     break;

            default:
                //column.Tickets = column.Tickets.sort((a, b) => (a.Position > b.Position ? 1 : -1));
                setColumn({ ...column, Tickets: column.Tickets });
                setSorted(true);
                setIsSorting(false);
                break;
        }
    };

    // const subscribed = useMemo(() => {
    //     if (user || column.Subscriptions) {
    //         var sub = column.Subscriptions.find((x) => x.ContactId === user.Id);
    //         if (sub !== null && sub?.IsActive) {
    //             return true;
    //         }
    //     }
    //     return false;
    // }, [user, column]);

    // const checkIsUserSubscribed = () => {
    //     if (column.Subscriptions == null) {
    //         return;
    //     }

    //     if (user === null) {
    //         setIsSubscribed(true);
    //         return;
    //     }

    //     let sub = column.Subscriptions.find((x) => x.ContactId === user.Id);

    //     if (sub !== null && sub?.IsActive) {
    //         setIsSubscribed(sub?.IsActive);
    //     }
    // };

    const handleEmailSubscriptions = async () => {
        await api.column.subscription.manageSubscription(user.Id, board.Board.Id, column.Column.Id, isSubscribed).then(() => {
            setIsSubscribed(!isSubscribed);
            setShowMenu(false);
        });
    };

    const archiveAllCards = () => {
        if (window.confirm("Are you sure you want to archive all cards in this column?")) {
            let tickets: number[] = [];
            for (var t of column.Tickets) {
                tickets.push(t.TicketDetails.Id);
            }
            api.ticket.archiveMultiple(tickets, user.Id);
            removeAllCardsFromColumns(item.Column.Id);
            setShowMenu(false);
        }
    };

    const moveAllCards = () => {
        for (var t of column.Tickets) {
            api.ticket
                .updatePosition(t.TicketDetails.Id, params.clientId, destinationColumnId, column.Tickets.length)
                // eslint-disable-next-line no-loop-func
                .then(() => {
                    api.ticket.get(t.TicketDetails.Id).then((data) => {
                        dispatch(actions.ticket.set(data));
                        dispatch(actions.board.set({ ...board }));
                    });
                })
                .then(() => {
                    setShowMenu(false);
                    setMoveCardsModalOpen(false);
                });
        }
    };

    const getUserColumnSubs = async () => {
        var data = await api.column.subscription.getById(column.Column.Id);
        if (user !== null) {
            let sub = data.find((x: SubscriptionType) => x.ContactId === user.Id);

            if (sub !== null && sub?.IsActive) {
                setIsSubscribed(!true);
            } else {
                setIsSubscribed(!false);
            }
        }
    };

    const checkUserIsBoardAdmin = useCallback(() => {
        api.board.member.getAll(params.boardId).then((data: BoardMemberType[]) => {
            if (user) {
                let i = data.find((x) => x.ContactId === user?.Id);

                if (i && i.RoleId > 1) {
                    setIsBoardAdmin(true);
                }
            }
        });
    }, [params.boardId]);

    useEffect(() => {
        setColumn(item);
        setIsSorting(false);
        // checkIsUserSubscribed();
        checkUserIsBoardAdmin();
    }, [item, SortColumn, sorted, newTicket]);

    useEffect(() => {
        getUserColumnSubs();
    }, [item]);

    return (
        <div className="column">
            <div className="column-header">
                <input
                    type="text"
                    value={columnTitle}
                    onChange={(e) => setColumnTitle(e.currentTarget.value)}
                    onBlur={updateColumn}
                    onKeyUp={(e) => {
                        if (e.key === "Enter") {
                            e.currentTarget.blur();
                        }
                    }}
                />
                <div className="counter-container">
                    {/* <span className="ticketcounter">({column.Tickets.filter((x) => x.IsArchived == false).length})</span> */}
                    <i className="fas fa-cog" onClick={() => setShowMenu(!showMenu)}>
                        &nbsp;&nbsp;({column.Tickets.filter((x) => x.TicketDetails.IsArchived === false).length})
                    </i>
                </div>
                {showMenu === true && (
                    <div className="menu-container">
                        <ul className={"open column-menu menu-lg"}>
                            <li onClick={() => handleEmailSubscriptions()}>{!isSubscribed ? "Unsubsribe from email notifications" : "Subsribe to email notifications"}</li>
                            {isBoardAdmin && (
                                <>
                                    {" "}
                                    <li onClick={() => setMoveCardsModalOpen(true)}>Move all cards</li>
                                    <li onClick={() => deleteColumn(column.Column.Id)}>Delete column</li>
                                    <li onClick={() => archiveAllCards()}>Archive all tickets</li>
                                </>
                            )}
                        </ul>
                    </div>
                )}
            </div>
            <Droppable droppableId={index.toString()} type="ticket">
                {(provided) => {
                    return (
                        <div className="column-body" ref={provided.innerRef} {...provided.droppableProps}>
                            {!isSorting ? <Tickets columns={columns} setColumns={getColumns} tickets={column.Tickets} index={index} /> : <></>}
                            {index === 0 && (
                                <Draggable draggableId={"100"} index={100} key={"100"} isDragDisabled={true}>
                                    {(provided) => {
                                        return (
                                            <div
                                                className={`new-ticket ${newTicket.open ? "open" : ""}`}
                                                tabIndex={0}
                                                onFocus={() =>
                                                    setNewTicket({
                                                        ...newTicket,
                                                        open: true,
                                                    })
                                                }
                                                onBlur={() =>
                                                    setNewTicket({
                                                        ...newTicket,
                                                        open: newTicket.title.length,
                                                    })
                                                }
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <textarea
                                                    placeholder={`${newTicket.open ? "Title" : "New Ticket"}`}
                                                    value={newTicket.title}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            addTicket();
                                                            e.currentTarget.blur();
                                                        }
                                                    }}
                                                    onChange={(e) =>
                                                        setNewTicket({
                                                            ...newTicket,
                                                            title: e.currentTarget.value,
                                                        })
                                                    }
                                                ></textarea>
                                                <i className="fal fa-calendar-alt"></i>
                                                <span>{newTicket.dueDate && moment(newTicket.dueDate).format("DD-MM-YYYY")}</span>
                                                <input
                                                    type="date"
                                                    value={newTicket.dueDate}
                                                    onChange={(e) =>
                                                        setNewTicket({
                                                            ...newTicket,
                                                            dueDate: e.currentTarget.value,
                                                        })
                                                    }
                                                />
                                                <button onClick={addTicket}>Add</button>
                                            </div>
                                        );
                                    }}
                                </Draggable>
                            )}
                            {provided.placeholder}
                        </div>
                    );
                }}
            </Droppable>
            <Modal open={moveCardsModalOpen} setOpen={setMoveCardsModalOpen}>
                <ModalHeader>Select Destination Column</ModalHeader>
                <ModalBody>
                    <div className="input-group boards">
                        {allColumns.map((x, i) => (
                            <div key={i}>
                                <label style={{ cursor: "pointer" }}>
                                    <input type="radio" name="radio-new-item-board" id={`check-column-${x.Column.Id}`} value={x.Column.Id} style={{ margin: "10px", cursor: "pointer" }} onChange={() => setDestinationColumnId(x.Column.Id)} />
                                    {x.Column.Description}
                                </label>
                            </div>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="button-group">
                        <button onClick={() => setMoveCardsModalOpen(false)}>Cancel</button>
                        <button className="btn-primary" onClick={moveAllCards}>
                            Move
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default Column;
